import React from 'react';

const ConfigPanel = ({ children, className }) => (
    <div className={`flex flex-column full-height ${className ?? ''}`}>{children}</div>
);

export default ConfigPanel;
